// PARAQTA қолданбасы (Capacitor iOS/Android) ішінде ғана іске қосылатын көпір.
// Браузердегі сайтқа ешқандай әсері жоқ: IN_APP=false болса бірден шығады.
//
//  · body.in-app — төлем/баға элементтері жасырылады (Apple 3.1.1: сандық тауар тек IAP арқылы)
//  · Кіру: Apple · Google (SocialLogin плагині) · Telegram (Safari → paraqta://auth?code=)
//  · paraqta://read → Оқу бетіне (NFC бетбелгідегідей сессия авто-басталады)
//  · Виджет күйі (стрик, бүгінгі шам, кітап) → Shyraq.setWidgetState
//  · Оқу сессиясы басталса/бітсе → Live Activity (құлып экраны + Dynamic Island)
//  · Push токені → /api/app/push-token

const UA = navigator.userAgent || '';
export const IN_APP = /PARAQTA-App\//.test(UA) || !!window.Capacitor?.isNativePlatform?.();
export const APP_PLATFORM = /PARAQTA-App\/\S+ Android/.test(UA) ? 'android' : 'ios';

// Google Cloud Console → OAuth client ID (iOS). Бос болса Google батырмасы көрінбейді.
const GOOGLE_IOS_CLIENT_ID = '613990211018-shk52tvin9rntl9ou0v7be2vb20vaoou.apps.googleusercontent.com';
const GOOGLE_WEB_CLIENT_ID = '613990211018-2hc9che3t9vtihc66ct5ufa7q0ro09ku.apps.googleusercontent.com';
// Google батырмасы тек Info.plist-те URL scheme бар құрастыруда (UA-да «gsi», 13.10-дан) — ескі нұсқада басса Google SDK құлатады
const GOOGLE_READY = /PARAQTA-App\/\S+ iOS gsi/.test(UA);

const P = () => window.Capacitor?.Plugins || {};
let _todayCache = null;

function hideCss() {
  const css = `
    body.in-app [data-action="open-jandos"], body.in-app [data-action="settings-jandos"], body.in-app [data-action="edit-custom-slug"], body.in-app [data-action="checkout-jandos"], body.in-app .jandos-tier-price, body.in-app .jandos-tier-per,
    body.in-app .mr-cta-btn, body.in-app .mr-cta-sub, body.in-app .mr-modal-price,
    body.in-app .mr-reg-pill, body.in-app [data-visibility="free-only"],
    body.in-app #tg-login-btn, body.in-app [data-pwa-install], body.in-app .pwa-install { display: none !important; }
    .app-login { display: grid; gap: 10px; margin: 6px 0 12px; }
    .app-login button { display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%;
      padding: 13px 16px; border-radius: 12px; border: 1px solid color-mix(in srgb, var(--ink) 18%, transparent);
      background: var(--bg); color: var(--ink); font: 600 15px/1 inherit; cursor: pointer; }
    .app-login .apple { background: #000; color: #fff; border-color: #000; }
    .app-login .tg { background: #2AABEE; color: #fff; border-color: #2AABEE; }
    .app-login small { display: block; text-align: center; color: var(--ink4); font-size: 12px; }`;
  const s = document.createElement('style');
  s.textContent = css;
  document.head.appendChild(s);
}

// ── Кіру ────────────────────────────────────────────────────────────
async function postToken(provider, idToken, name) {
  const r = await fetch(`/api/auth/${provider}`, {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id_token: idToken, name: name || '' }),
  });
  if (!r.ok) {
    const j = await r.json().catch(() => ({}));
    throw new Error(j.detail || 'Кіру сәтсіз болды');
  }
  location.href = '/';
}

async function providerToken(provider) {
  const SL = P().SocialLogin;
  if (!SL) throw new Error('Бұл нұсқада қолжетімсіз');
  const opts = provider === 'apple' ? { scopes: ['email', 'name'] } : { scopes: ['email', 'profile'] };
  const res = await SL.login({ provider, options: opts });
  const r = res?.result || {};
  const tok = r.idToken || r.identityToken;
  if (!tok) throw new Error('Токен келмеді');
  const name = [r.profile?.givenName, r.profile?.familyName].filter(Boolean).join(' ') || r.profile?.name || '';
  return { tok, name };
}

// Баптаулар → Аккаунт: кіріп тұрған (Telegram) аккаунтқа Apple/Google қосу. Сервер бар аккаунтқа байлайды.
// Қайтарады: null — сәтті; 'cancel' — адам бас тартты; әйтпесе қате мәтіні.
export const LINKABLE = () => [APP_PLATFORM === 'ios' ? 'apple' : null, GOOGLE_IOS_CLIENT_ID && GOOGLE_READY ? 'google' : null].filter(Boolean);
export async function linkProvider(provider) {
  try {
    const { tok, name } = await providerToken(provider);
    const r = await fetch(`/api/auth/${provider}`, {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id_token: tok, name }),
    });
    if (r.ok) return null;
    const j = await r.json().catch(() => ({}));
    return j.detail || 'Қосылмады. Қайта байқап көр.';
  } catch (e) {
    const msg = String(e?.message || e);
    return /cancel/i.test(msg) ? 'cancel' : msg;
  }
}

async function loginWith(provider, btn) {
  if (!P().SocialLogin) return;
  btn.disabled = true;
  try {
    const { tok, name } = await providerToken(provider);
    await postToken(provider, tok, name);
  } catch (e) {
    const msg = String(e?.message || e);
    if (!/cancel/i.test(msg)) alertBox(msg);
  } finally {
    btn.disabled = false;
  }
}

function alertBox(msg) {
  const el = document.querySelector('.app-login small');
  if (el) el.textContent = msg;
}

function mountLoginButtons() {
  const host = document.getElementById('tg-login-btn');
  if (!host || document.querySelector('.app-login')) return;
  const box = document.createElement('div');
  box.className = 'app-login';
  const google = GOOGLE_IOS_CLIENT_ID && GOOGLE_READY ? '<button type="button" class="google">G&nbsp; Google арқылы кіру</button>' : '';
  const apple = APP_PLATFORM === 'ios' ? '<button type="button" class="apple"> Apple арқылы кіру</button>' : '';
  box.innerHTML = `${apple}${google}<button type="button" class="tg">Telegram арқылы кіру</button><small></small>`;
  host.parentNode.insertBefore(box, host);
  box.querySelector('.apple')?.addEventListener('click', e => loginWith('apple', e.currentTarget));
  box.querySelector('.google')?.addEventListener('click', e => loginWith('google', e.currentTarget));
  box.querySelector('.tg').addEventListener('click', () => {
    P().Browser?.open({ url: `${location.origin}/api/auth/app-login`, presentationStyle: 'popover' });
  });
  const desc = document.querySelector('#loginModal .login-modal-desc');
  if (desc) desc.textContent = 'Парольсіз, 30 секундта. Қалауыңша кір.';
}

// ── А1 (13.10): қолданбаның алғашқы экраны — кірмеген адамға сайттың лендингі ЕМЕС, бір экран:
// 2D Шырақ + Ыбырай жолы + кіру батырмалары (Apple · Google · Telegram). Кірген соң location.href='/' → жоғалады.
// Браузерде көру үшін (тек кірмеген күйде): ?welcome=preview
const WELCOME_CSS = `
.pq-welcome{--w-bg:#F6EFE3;--w-ink:#22201B;--w-sub:#5A5247;--w-acc:#9A5B12;position:fixed;inset:0;z-index:400;background:var(--w-bg);color:var(--w-ink);
  display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;box-sizing:border-box;
  padding:calc(24px + env(safe-area-inset-top,0px)) 24px calc(24px + env(safe-area-inset-bottom,0px));font-family:"PT Sans",system-ui,sans-serif;overflow-y:auto}
@media (prefers-color-scheme: dark){:root:not([data-theme="light"]) .pq-welcome{--w-bg:#16120D;--w-ink:#F0E8DA;--w-sub:#C9BCA6;--w-acc:#E9A949}}
:root[data-theme="dark"] .pq-welcome{--w-bg:#16120D;--w-ink:#F0E8DA;--w-sub:#C9BCA6;--w-acc:#E9A949}
.pq-welcome .wm{font:700 13px "IBM Plex Mono",monospace;letter-spacing:.32em;color:var(--w-sub);margin-bottom:6px}
.pq-welcome blockquote{margin:6px 0 2px;font:italic 700 26px/1.25 "PT Serif",Georgia,serif;color:var(--w-acc);text-wrap:balance}
.pq-welcome cite{display:block;margin-top:8px;font:600 11.5px "IBM Plex Mono",monospace;letter-spacing:.16em;color:var(--w-sub);font-style:normal;margin-bottom:14px}
.pq-welcome .sub{max-width:300px;margin:12px auto 22px;font-size:16px;line-height:22px;color:var(--w-sub)}
.pq-welcome .app-login{display:grid;gap:10px;width:100%;max-width:340px}
.pq-welcome .app-login button{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;border:1px solid transparent;cursor:pointer}
.pq-welcome .app-login .apple{background:#000;color:#fff}.pq-welcome .app-login .tg{background:#2AABEE;color:#fff}.pq-welcome .app-login .google{background:#fff;color:#22201B;border-color:#DADCE0}
.pq-welcome .app-login small{display:block;text-align:center;color:var(--w-sub);font-size:12px;min-height:14px}
.pq-welcome .app-login button{min-height:52px;border-radius:16px;font:700 16px "PT Sans",sans-serif}
.pq-welcome .more{margin-top:14px;background:none;border:0;color:var(--w-sub);font-size:14px;text-decoration:underline;min-height:40px;cursor:pointer}
.pq-welcome .legal{margin-top:6px;font-size:11.5px;color:var(--w-sub);opacity:.8;max-width:300px}`;

function loginBox() {
  const box = document.createElement('div');
  box.className = 'app-login';
  const google = GOOGLE_IOS_CLIENT_ID && GOOGLE_READY ? '<button type="button" class="google">G&nbsp; Google арқылы кіру</button>' : '';
  const apple = APP_PLATFORM === 'ios' ? '<button type="button" class="apple"> Apple арқылы кіру</button>' : '';
  box.innerHTML = `${apple}${google}<button type="button" class="tg">Telegram арқылы кіру</button><small></small>`;
  box.querySelector('.apple')?.addEventListener('click', e => loginWith('apple', e.currentTarget));
  box.querySelector('.google')?.addEventListener('click', e => loginWith('google', e.currentTarget));
  box.querySelector('.tg').addEventListener('click', () => {
    P().Browser?.open({ url: `${location.origin}/api/auth/app-login`, presentationStyle: 'popover' });
  });
  return box;
}

export async function mountWelcome() {
  if (document.querySelector('.pq-welcome')) return;
  if (!document.getElementById('pq-welcome-css')) {
    const st = document.createElement('style'); st.id = 'pq-welcome-css'; st.textContent = WELCOME_CSS; document.head.appendChild(st);
  }
  let svg = '';
  try { svg = (await import('./shyraq2d.js')).shyraqSVG({ mood: 'wave', size: 190 }); } catch (_) {}
  const w = document.createElement('div');
  w.className = 'pq-welcome'; w.setAttribute('role', 'dialog'); w.setAttribute('aria-label', 'PARAQTA-ға қош келдің');
  w.innerHTML = `<div class="wm">PARAQTA</div>${svg}
    <blockquote>Оқысаңыз, балалар,<br>шамнан шырақ жағылар.</blockquote><cite>ЫБЫРАЙ АЛТЫНСАРИН</cite>
    <p class="sub">Күнде аздап оқы. Шырағың жанып, серияң өседі.</p>
    <div class="slot"></div>
    <button type="button" class="more">Алдымен қарап шығайын</button>
    <p class="legal">Кіру арқылы пайдалану шарттарымен келісесің.</p>`;
  w.querySelector('.slot').replaceWith(loginBox());
  w.querySelector('.more').addEventListener('click', () => { w.remove(); document.body.style.overflow = ''; });
  document.body.appendChild(w);
  document.body.style.overflow = 'hidden';
  try { import('./track.js').then(m => m.track('app_welcome')); } catch (_) {}
}

// ── Терең сілтеме: paraqta://auth?code=… · paraqta://read ──────────────
function handleUrl(url) {
  let u;
  try { u = new URL(url); } catch { return; }
  const host = u.host || u.pathname.replace(/^\/+/, '').split('/')[0];
  if (host === 'auth') {
    P().Browser?.close?.().catch?.(() => {});
    const code = u.searchParams.get('code');
    if (code) location.href = `/api/auth/app-exchange?code=${encodeURIComponent(code)}`;
    else alertBox('Telegram арқылы кіру сәтсіз. Қайта байқап көр.');
  } else if (host === 'read') {
    location.href = '/oqu';
  }
}

// ── Виджет ──────────────────────────────────────────────────────────
function almatyToday() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Almaty' }).format(new Date());
}

let _widget = null;   // /api/app/widget соңғы жауабы (Live Activity мақсаты үшін)
async function syncWidget() {
  const S = P().Shyraq;
  if (!S) return;
  // 11.10: бай виджеттер — бір сұрау (сервер ескі болса 404 → төмендегі ескі жол)
  try {
    const w = await fetch('/api/app/widget', { credentials: 'include' }).then(r => (r.ok ? r.json() : null));
    if (w && w.ok) {
      _widget = w;
      await S.setWidgetState({
        name: w.name || '', streak: Number(w.streak || 0),
        lastReadDate: w.read_today ? almatyToday() : '',
        todayPages: Number(w.today_pages || 0), todayMinutes: Number(w.today_minutes || 0),
        bookTitle: w.book?.title || '', bookAuthor: w.book?.author || '',
        bookPage: Number(w.book?.page || 0), bookTotal: Number(w.book?.total || 0),
        goalPages: Number(w.goal_pages || 0), week: Array.isArray(w.week) ? w.week.map(Boolean) : [],
        friendsReading: Number(w.room?.count || 0), roomNames: w.room?.names || [],
        quoteText: w.quote?.text || '', quoteSource: w.quote?.source || '', outfit: '',
      });
      return;
    }
  } catch (e) { /* төменгі ескі жолға */ }
  try {
    const [t, h] = await Promise.all([
      fetch('/api/today/v2', { credentials: 'include' }).then(r => (r.ok ? r.json() : null)),
      fetch('/api/sessions/hearth', { credentials: 'include' }).then(r => (r.ok ? r.json() : null)).catch(() => null),
    ]);
    if (!t) return;
    _todayCache = t;
    const pages = Number(t.today_sessions_total_pages || 0);
    const minutes = Number(t.today_minutes || 0);
    const readToday = pages > 0 || minutes >= 5;
    await S.setWidgetState({
      name: t.user?.name || '',
      streak: Number(t.user?.streak ?? t.my_streak ?? 0),
      lastReadDate: readToday ? almatyToday() : '',
      todayPages: pages,
      todayMinutes: minutes,
      bookTitle: t.reading_now?.[0]?.title || '',
      friendsReading: Number(h?.active_count || 0),
      outfit: '',
    });
  } catch (e) { /* виджет — қосымша; қате сайтқа әсер етпейді */ }
}

// ── Live Activity: сессияның басталуы/аяқталуы ──────────────────────
function watchSessions() {
  const orig = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const res = await orig(input, init);
    try {
      const url = typeof input === 'string' ? input : input?.url || '';
      if (res.ok && /\/api\/sessions\/start(\?|$)/.test(url)) {
        res.clone().json().then(j => {
          const title = _todayCache?.reading_now?.[0]?.title
            || document.querySelector('[data-current-book-title]')?.textContent?.trim() || 'Кітап';
          const started = j?.started_at ? Date.parse(j.started_at) : Date.now();
          const b = _widget?.book;
          P().Shyraq?.startReading({
            bookTitle: title, startedAt: Number.isFinite(started) ? started : Date.now(),
            pagesToday: Number(_widget?.today_pages || 0), goalPages: Number(_widget?.goal_pages || 0),
            subtitle: b && b.title === title && b.page ? (b.total ? `${b.page} / ${b.total} беттен бастадың` : `${b.page}-беттен бастадың`) : '',
          });
        }).catch(() => {});
      } else if (res.ok && /\/api\/sessions\/save(\?|$)/.test(url)) {
        P().Shyraq?.stopReading();
        setTimeout(syncWidget, 1500);
      }
    } catch { /* тек бақылау */ }
    return res;
  };
}

// ── Push ────────────────────────────────────────────────────────────
// Қолданбада хабарламаға рұқсат — iPhone-ның өз push-ы (Telegram да, веб-push та емес). Баптаулардан шақырылады.
export async function askNativePush() {
  const PN = P().PushNotifications;
  if (!PN) return false;
  try {
    let st = await PN.checkPermissions();
    if (st.receive !== 'granted') st = await PN.requestPermissions();
    if (st.receive === 'granted') { await PN.register(); return true; }
  } catch { /* рұқсат берілмеді */ }
  return false;
}

// 13.10: push қай қадамда тоқтайтынын көру үшін (телефонның ішін көре алмаймыз) — events кестесіне
const pushLog = (stage, meta) => { try { import('./track.js').then(m => m.track('app_push', Object.assign({ stage }, meta || {}))); } catch (_) {} };
async function initPush() {
  const PN = P().PushNotifications;
  if (!PN) { pushLog('no_plugin'); return; }
  try {
    PN.addListener('registrationError', e => pushLog('reg_error', { err: String((e && (e.error || e.message)) || e).slice(0, 160) }));
    PN.addListener('registration', ({ value }) => {
      pushLog('token', { len: String(value || '').length });
      fetch('/api/app/push-token', {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: value, platform: APP_PLATFORM }),
      }).catch(() => {});
    });
    PN.addListener('pushNotificationActionPerformed', ({ notification }) => {
      const link = notification?.data?.url;
      if (link && link.startsWith('/')) location.href = link;
    });
    let st = await PN.checkPermissions();
    pushLog('check', { receive: st.receive });
    if (st.receive === 'prompt') {
      // Бірінші шамнан кейін ғана сұраймыз — бірінші экранда емес
      if (!localStorage.getItem('pq_app_push_asked') && _todayCache && Number(_todayCache.user?.streak || 0) > 0) {
        localStorage.setItem('pq_app_push_asked', '1');
        st = await PN.requestPermissions();
      }
    }
    if (st.receive === 'granted') { await PN.register(); pushLog('register_called'); }
  } catch (e) { pushLog('exception', { err: String(e && e.message || e).slice(0, 160) }); }
}

export async function initNative() {
  if (!IN_APP) return;
  document.body.classList.add('in-app', `in-app-${APP_PLATFORM}`);
  hideCss();
  mountLoginButtons();
  try {
    await P().SocialLogin?.initialize?.({
      apple: {},
      ...(GOOGLE_IOS_CLIENT_ID && GOOGLE_READY ? { google: { iOSClientId: GOOGLE_IOS_CLIENT_ID, iOSServerClientId: GOOGLE_WEB_CLIENT_ID || undefined } } : {}),
    });
  } catch { /* плагин жоқ — батырма қате көрсетеді */ }
  P().App?.addListener?.('appUrlOpen', ({ url }) => handleUrl(url));
  P().App?.addListener?.('appStateChange', ({ isActive }) => { if (isActive) syncWidget(); });
  watchSessions();
  const me = await fetch('/api/auth/me', { credentials: 'include' }).then(r => (r.ok ? r.json() : null)).catch(() => null);
  if (me?.authenticated) {
    await syncWidget();
    initPush();
  } else {
    mountWelcome();          // А1: лендингтің орнына алғашқы экран
  }
}
